module.exports = __webpack_public_path__ + "media/tr_tr_s3_Muhammed.3e285e3b.oga";